import { render, staticRenderFns } from "./WorkspaceSaveGraphModal.vue?vue&type=template&id=8e932b64&scoped=true"
import script from "./WorkspaceSaveGraphModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceSaveGraphModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSaveGraphModal.vue?vue&type=style&index=0&id=8e932b64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e932b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e932b64')) {
      api.createRecord('8e932b64', component.options)
    } else {
      api.reload('8e932b64', component.options)
    }
    module.hot.accept("./WorkspaceSaveGraphModal.vue?vue&type=template&id=8e932b64&scoped=true", function () {
      api.rerender('8e932b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceSaveGraphModal.vue"
export default component.exports